import { useEffect } from "react";
import LegalLayout from "@/components/LegalLayout";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

export default function Legal() {
    useEffect(() => {
        document.title = "Aviso legal — Aurum Vanguard";
        window.scrollTo({ top: 0 });
    }, []);

    return (
        <>
            <Navigation />
            <LegalLayout
                title="Aviso legal"
                subtitle="Información legal sobre el titular del sitio, las condiciones de uso y el marco jurídico aplicable a aurumvanguard.cloud."
                lastUpdate="12 de mayo de 2026"
            >
                <h2>1. Titularidad del sitio</h2>
                <p>
                    De conformidad con la Ley 34/2002, de 11 de julio, de Servicios de la
                    Sociedad de la Información y de Comercio Electrónico (LSSI-CE) y el
                    Federal Decree-Law nº 14/2023 on Modern Technology Trading aplicable en
                    EAU, se informa de los siguientes datos:
                </p>
                <ul>
                    <li>
                        <strong>Denominación:</strong> Aurum Vanguard — Strategic Growth &
                        Innovation Firm.
                    </li>
                    <li>
                        <strong>Domicilio profesional:</strong> Dubai, Emiratos Árabes Unidos.
                    </li>
                    <li>
                        <strong>Correo electrónico de contacto:</strong>{" "}
                        <a href="mailto:hello@aurumvanguard.com">hello@aurumvanguard.com</a>.
                    </li>
                    <li>
                        <strong>Dominio:</strong> aurumvanguard.cloud (en transición a
                        aurumvanguard.com).
                    </li>
                </ul>
                <p>
                    Los datos registrales, de licencia comercial DED Dubai y, en su caso,
                    inscripción en el Registro Mercantil correspondiente serán publicados en
                    esta página tan pronto se complete el procedimiento administrativo en
                    curso.
                </p>

                <h2>2. Objeto y ámbito</h2>
                <p>
                    Este sitio tiene una finalidad estrictamente informativa y profesional. La
                    información publicada se dirige a profesionales y empresas interesadas en
                    los servicios de Aurum Vanguard, y no constituye oferta vinculante ni
                    asesoramiento personalizado.
                </p>

                <h2>3. Propiedad intelectual e industrial</h2>
                <p>
                    Todos los contenidos del sitio — textos, marcas, logotipos, identidad
                    visual, código fuente, metodología <em>Smart Sales Systems</em>™ y
                    cualquier otro elemento — son titularidad de Aurum Vanguard o de sus
                    licenciantes. Queda prohibida su reproducción, distribución, comunicación
                    pública o transformación, total o parcial, sin autorización expresa y por
                    escrito del titular.
                </p>

                <h2>4. Condiciones de uso</h2>
                <p>El usuario se compromete a:</p>
                <ul>
                    <li>Utilizar el sitio conforme a la ley, la moral y el orden público.</li>
                    <li>No introducir contenidos ilícitos, ofensivos o que infrinjan derechos de terceros.</li>
                    <li>No realizar acciones que puedan dañar, sobrecargar o deteriorar el funcionamiento del sitio.</li>
                </ul>

                <h2>5. Responsabilidad</h2>
                <p>
                    Aurum Vanguard adopta medidas razonables para mantener el sitio
                    disponible, actualizado y libre de errores, pero no garantiza la ausencia
                    absoluta de interrupciones, virus u otros elementos lesivos. No será
                    responsable por daños derivados del uso del sitio cuando concurra culpa o
                    dolo del usuario, fuerza mayor o caso fortuito.
                </p>

                <h2>6. Enlaces externos</h2>
                <p>
                    El sitio puede contener enlaces a webs de terceros (por ejemplo, Cal.com
                    para la reserva de llamadas). Aurum Vanguard no asume responsabilidad por
                    el contenido, las políticas o las prácticas de dichos sitios.
                </p>

                <h2>7. Protección de datos</h2>
                <p>
                    El tratamiento de datos personales se rige por la{" "}
                    <a href="/privacidad">Política de privacidad</a> y por la{" "}
                    <a href="/cookies">Política de cookies</a>, accesibles desde este mismo
                    sitio.
                </p>

                <h2>8. Legislación aplicable y jurisdicción</h2>
                <p>
                    Este aviso legal se rige por la legislación de los Emiratos Árabes Unidos
                    y, subsidiariamente, por la normativa española y de la Unión Europea
                    cuando resulte aplicable por la residencia del usuario. Las partes se
                    someten, con renuncia expresa a cualquier otro fuero, a los tribunales
                    competentes de Dubai — o, alternativamente y para usuarios consumidores
                    residentes en la Unión Europea, a los tribunales de su domicilio.
                </p>
            </LegalLayout>
            <Footer />
        </>
    );
}
